// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"9":"71c7b47c","526":"e78200de"}[chunkId] + ".chunk.css";
};